import StringUtils from '../../utils/string-utils';
import OpeningHours from '../../utils/opening-hours';
import DealerMapper from '../../utils/dealer-mapper';
import LinkHelper from '../../utils/link-helper';
import CurrencyFormatter from '../../utils/currency-formatter-lib';
import { getNumberWithDecimals } from '../../utils/number-utils';

export default class EligibilityView {
    constructor(parent, router) {
        this.router = router;
        this.parent = parent;
        this.form = this.parent.form;
        this.el = parent.el.querySelector('.eligibility-view');
        this.eligibilityCta = this.el.querySelector('#eligibility-cta');
        this.backLink = this.el.querySelector('#back-to-privacy');
        this.financeTable = this.el.querySelector('.finance-table');
        this.financeTableTemplate = _.template(this.el.querySelector('#finance-table-template').innerHTML.replaceAll('\\', '')),
        this.financeSuitabilityTypes = [...this.el.querySelectorAll('.finance-suitability-type')];
        this.financeTitles = [...this.el.querySelectorAll('.finance-title')];
        this.retailerDetails = this.el.querySelector('.chosen-retailer .chosen-retailer__details');

        this.priceFormatter = new CurrencyFormatter();

        this.bind();
    }

    setEligible(checked) {
        const checkboxes = [...this.el.querySelectorAll('input[type="checkbox"]')];
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checked;
        });
    }

    setupFinanceSuitability(order) {
        const type = order?.financeSummary?.financeType;
        this.financeSuitabilityTypes.forEach((t) => {
            if (t.dataset.id === type) {
                t.classList.remove('hide');
                this.form.enable(t);
            } else {
                t.classList.add('hide');
                this.form.disable(t);
            }
        });

        this.financeTitles.forEach((t) => t.dataset.id === type ? t.classList.remove('hide') :  t.classList.add('hide'));
        this.financeTable.innerHTML = this.financeTableTemplate({
            order,
            stringReplace: StringUtils.replace,
            formatPrice: (val) => this.priceFormatter.to(val),
            getPercentage: ({ number, numberOfDecimals }) => `${getNumberWithDecimals({ number, numberOfDecimals })}%`,
        });

        this.fetchOrderedDealerData(order);
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    bind() {
        this.form.addEventListener('onUpdate', async (field) => {
            if (this.el.contains(field.el)) {
                const populated = await this.isPopulated();
                if (populated) {
                    this.eligibilityCta.classList.remove('disabled');
                } else {
                    this.eligibilityCta.classList.add('disabled');
                }
            }
        });

        this.eligibilityCta.addEventListener('click', async (e) => {
            e.preventDefault();
            const valid = await this.isValid();
            if (valid) {
                this.analyticsPush(e.currentTarget, this.parent.order?.summary?.ids?.modeCode);
                this.router.update('form');
            }
        });

        this.backLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.router.update('privacy');
        });
    }

    async fetchOrderedDealerData(orderData) {
        this.dealerUrl = this.retailerDetails.dataset.dealerUrl;
        this.closedLabel = this.retailerDetails.dataset.closedLabel;
        this.contactLabel = this.retailerDetails.dataset.contactLabel;
        this.contactForm = this.retailerDetails.dataset.contactForm;
        const dealerCode = orderData?.dealer?.dealerCode;
        const result = dealerCode ? await window.HONDA.MyAccount2.client.getDealerDetails(this.dealerUrl, dealerCode) : null;
        if (result) {
            const dealerData = DealerMapper.map(result);
            this.bindDealerData(dealerData);
        }
    }

    bindDealerData(dealer) {
        const dealerName = this.retailerDetails.querySelector('.dealer-name');
        const dealerAddress = this.retailerDetails.querySelector('.dealer-address');
        const dealerHours = this.retailerDetails.querySelector('.timing');
        const dealerPhone = this.retailerDetails.querySelector('.dealer-telephone a');
        const dealerEmail = this.retailerDetails.querySelector('.dealer-email a');

        if (dealerName) {
            dealerName.innerHTML = dealer.name;
        }
        if (dealerAddress) {
            dealerAddress.innerHTML = dealer.address.formatted;
        }
        if (dealerHours) {
            dealerHours.innerHTML = OpeningHours.html(dealer.openingHours, this.closedLabel);
        }
        if (dealerPhone) {
            dealerPhone.href = `tel:${dealer.telephone}`;
            dealerPhone.innerHTML = dealer.telephone;
        }
        if (dealerEmail) {
            if (dealer.contactForm) {
                dealerEmail.textContent = this.contactLabel;
                dealerEmail.href = `${LinkHelper.dotHtml(dealer.contactForm)}?dealerId=${dealer.uri}`;
            } else if (this.contactForm) {
                dealerEmail.textContent = this.contactLabel;
                dealerEmail.href = `${LinkHelper.dotHtml(this.contactForm)}?dealerId=${dealer.uri}`;
            } else {
                dealerEmail.textContent = dealer.email;
                dealerEmail.href = `mailto:${dealer.email}`;
            }
        }
    }

    async isValid() {
        const fields = this.form.elementFields(this.el);
        const valid = await this.form.valid(fields);
        return valid;
    }

    async isPopulated() {
        const fields = this.form.elementFields(this.el);
        const populated = await this.form.populated(fields);
        return populated;
    }

    analyticsPush(el, model) {
        this.parent.AnalyticsHelper.template(el, { model });
        this.parent.AnalyticsHelper.push(el);
    }
}
